module.exports = __webpack_public_path__ + "static/media/model2.6d8a1811.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model2.jpeg
// module id = 46
// module chunks = 0